// removed by extract-text-webpack-plugin
module.exports = {"container":"OptInTermsDialog__container___2pn9z","iframeContainer":"OptInTermsDialog__iframeContainer___3AzHT","buttonRow":"OptInTermsDialog__buttonRow___3aAze"};


//////////////////
// WEBPACK FOOTER
// ./src/options/components/OptInTermsDialog.css
// module id = 762
// module chunks = 0